// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"549":"2420d1cae3971780","1197":"2eb4066051bcd8e1","2341":"24dd4a9cc18fe4e1","5297":"45f72bf81de684c3"}[chunkId] + ".js";
};